import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useStyles } from './ClubBalanceBar.style';
import { ClubBalanceCard } from '../ClubBalanceCard';
export const ClubBalanceBar = ({ label, userBalance, hasBorder = false }) => {
    const classes = useStyles();
    return (React.createElement(Box, { sx: hasBorder ? classes.menuBorder : classes.menuBorderless },
        React.createElement(Box, { sx: classes.menuItem },
            React.createElement(Typography, { sx: classes.menuItemTitle }, label),
            React.createElement(ClubBalanceCard, { balance: userBalance, small: false, iconHeight: '18', iconWidth: '50' }))));
};
